import { render, staticRenderFns } from "./BdRouteChannelInfoEdit.vue?vue&type=template&id=5a0d91e8&scoped=true&"
import script from "./BdRouteChannelInfoEdit.vue?vue&type=script&lang=js&"
export * from "./BdRouteChannelInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./BdRouteChannelInfoEdit.vue?vue&type=style&index=0&id=5a0d91e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d91e8",
  null
  
)

export default component.exports